import AccountIcon from '../../../components/Icons/AccountIcon';
import ApiKeyIcon from '../../../components/Icons/ApiKeyIcon';
import DashboardIcon from '../../../components/Icons/DashboardIcon';
import DriverListIcon from '../../../components/Icons/DriverListIcon';
import DriverSetupIcon from '../../../components/Icons/DriverSetupIcon';
import LookupIcon from '../../../components/Icons/LookupIcon';
import ProfileIcon from '../../../components/Icons/ProfileIcon';
import SettingIcon from '../../../components/Icons/SettingIcon';
import ShieldIcon from '../../../components/Icons/ShieldIcon';
import TripLogIcon from '../../../components/Icons/TripLogIcon';
import {
  DASHBOARD,
  DRIVER_LIST,
  DRIVER_SETUP,
  LOOKUP,
  SETTINGS,
  SETTINGS_ACCOUNT_AND_SECURITY,
  SETTINGS_ACCOUNT_MANAGEMENT,
  SETTINGS_API_KEYS,
  SETTINGS_PROFILE,
  TRIP_LOG,
} from '../../../routes/routeConstants';

interface INavConfig {
  title: string;
  path: string;
  icon: any;
}

export const navConfig: INavConfig[] = [
  {
    title: 'Dashboard',
    path: DASHBOARD,
    icon: <DashboardIcon />,
  },
  {
    title: 'Driver Setup',
    path: DRIVER_SETUP,
    icon: <DriverSetupIcon />,
  },
  {
    title: 'Lookup',
    path: LOOKUP,
    icon: <LookupIcon />,
  },
  {
    title: 'Trip Log',
    path: TRIP_LOG,
    icon: <TripLogIcon />,
  },
  {
    title: 'Driver List',
    path: `${DRIVER_LIST}?tab-segment=Drivers`,
    icon: <DriverListIcon />,
  },
  {
    title: 'Settings',
    path: SETTINGS,
    icon: <SettingIcon />,
  },
];

export const settingNavConfig: INavConfig[] = [
  {
    title: 'Profile Settings',
    path: `/${SETTINGS_PROFILE}`,
    icon: <ProfileIcon />,
  },
  {
    title: 'Account and Security',
    path: `/${SETTINGS_ACCOUNT_AND_SECURITY}`,
    icon: <ShieldIcon />,
  },
  {
    title: 'Account Management',
    path: `/${SETTINGS_ACCOUNT_MANAGEMENT}`,
    icon: <AccountIcon />,
  },
  {
    title: 'API Keys',
    path: `/${SETTINGS_API_KEYS}`,
    icon: <ApiKeyIcon />,
  },
];
